import React from 'react';
import BarsSolid from './bars-solid.svg';

const HamburgerIcon = ({styles, className}) => {
    return (
        <img src={BarsSolid} style={styles} className={className} alt="Hamburger Menu Icon" />
    )
}

export default HamburgerIcon;